import { AfterViewInit, Component, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import * as uuid from 'uuid';
import { BcitiSelectGridDropdownComponent } from '../select-grid-dropdown/bciti-select-grid-dropdown.component';

@Component({
    selector: 'app-bciti-icon-select',
    templateUrl: './bciti-icon-select.component.html',
    styleUrls: ['./bciti-icon-select.component.scss'],
})
export class BcitiIconSelectComponent implements OnInit, ControlValueAccessor {
    public onChange: (v?: any) => {};
    public onTouched: () => {};
    public id: string;
    public _value = '';

    @ViewChild(MatSelect) matSelect: MatSelect;

    @Input() icons: string[] = [];

    @Input() disabled: boolean;

    @Input() validation = true;

    @Input() width: string = '80px';

    @Output('change') changeOutput = new EventEmitter<string>();

    @Output() blur = new EventEmitter<Event>();

    @ViewChild(BcitiSelectGridDropdownComponent)
    public dropdown: BcitiSelectGridDropdownComponent;

    @Input()
    get value(): string {
        return this._value;
    }

    set value(v: string) {
        this._value = v;
        this.changeOutput.emit(v);
        if (this.onChange) {
            this.onChange(v);
            this.onTouched();
        }
    }

    get invalid() {
        if (this.ngControl) {
            return this.ngControl.invalid;
        }
        return false;
    }

    get valid() {
        if (this.ngControl) {
            return this.ngControl.valid;
        }
        return false;
    }

    get pristine() {
        if (this.ngControl) {
            return this.ngControl.pristine;
        }
        return false;
    }

    get dirty() {
        if (this.ngControl) {
            return this.ngControl.dirty;
        }
        return false;
    }

    get touched() {
        if (this.ngControl) {
            return this.ngControl.touched;
        }
        return false;
    }

    constructor(@Self() @Optional() private ngControl: NgControl) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngOnInit(): void {
        this.id = uuid.v4();
        if (!this.value) {
            this.valueChange(this.icons[Math.floor(Math.random() * this.icons.length)]);
            this.ngControl.control.markAsPristine();
            this.ngControl.control.markAsUntouched();
        }
    }

    valueChange(e: any) {
        this.value = e;
    }

    onBlur(event: Event): void {
        this.blur.emit(event);
        if (this.onTouched) {
            this.onTouched();
        }
    }
    writeValue(value: string): void {
        this._value = value;
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    select(icon: string): void {
        this.valueChange(icon);
        this.dropdown.hide();
    }

    showDropdown() {
        if (!this.disabled) {
            this.dropdown.show();
        }
    }

    hideDropdown() {
        this.dropdown.hide();
    }
}
